import { render, staticRenderFns } from "./PersonalLocalization.vue?vue&type=template&id=8246595a&"
import script from "./PersonalLocalization.vue?vue&type=script&lang=ts&"
export * from "./PersonalLocalization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports